import { render, staticRenderFns } from "./OfferFilipino4uWelcome.vue?vue&type=template&id=139ae83c&"
import script from "./OfferFilipino4uWelcome.vue?vue&type=script&lang=js&"
export * from "./OfferFilipino4uWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports